import { createApi } from 'helpers/hotelModuleHelper';
import client from 'apis/apiv2';

export default createApi('TrattamentoHotel', client);
